/**
 * Application route paths configuration.
 * Defines all available routes in the application.
 */
export const ROUTE_PATHS = Object.freeze({
  CFMP: '/compras-fuera-de-mercado-publico',
  NOT_FOUND: '*',
  ROOT: '/'
})
